<template>
  <div>
    <Header />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div
      class="container mx-auto max-w-[1200px] w-full py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div class="w-full h-full flex flex-col gap-5">
        <div
          class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between"
        >
          <div>
            <h1 class="text-xl font-semibold">
              Report Logs
              <span class="text-[16px]" v-if="downloadcount"
                >({{ downloadcount || 0 }})</span
              >
            </h1>
          </div>
          <div class="flex flex-wrap gap-2">
            <div class="relative md:col-span-2">
              <input
                type="text"
                v-model="searching"
                @input="getDownloadLogs(1)"
                placeholder="Search ..."
                class="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 pr-10 text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <img
                src="@/assets/search_icon1.svg"
                class="absolute right-4 top-1/2 -translate-y-1/2 h-4 w-4 opacity-50"
              />
            </div>
          </div>
        </div>

        <div>
          <div class="w-full pb-20">
            <div v-if="this.Download_list.length > 0">
              <div
                class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
              >
                <table class="min-w-full text-sm">
                  <thead class="bg-gray-100 whitespace-nowrap">
                    <tr>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        S.No
                      </th>

                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Title
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Created By
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Send Date
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-center"
                      >
                        Select Student Count
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-100">
                    <tr
                      v-for="(el, index) in Download_list"
                      :key="el.id"
                      class="hover:bg-gray-50 whitespace-nowrap"
                    >
                      <td class="py-3 px-4 border-r text-left text-xs">
                        {{ (currentPage - 1) * pageSize + index + 1 }}
                      </td>

                      <td class="py-3 px-4 border-r text-left">
                        <div
                          class="inline-block text-[13px] font-medium text-blue-600 hover:text-blue-800 no-underline max-w-[200px] truncate"
                        >
                          {{ el.title || "NA" }}
                        </div>
                        <div
                          class="text-xs truncate max-w-[200px]"
                          :title="el.subject"
                        >
                          <span class="text-gray-600 text-xs">Subject:</span>
                          {{ el.subject || "No content" }}
                        </div>
                      </td>
                      <td class="py-3 px-4 border-r text-xs text-left">
                        <div
                          class="text-blue-600 hover:text-blue-800 font-medium truncate capitalize"
                        >
                          {{ el.created_by?.display_name || "NA" }}
                        </div>
                        <div
                          class="text-xs truncate max-w-[200px]"
                          v-if="el.created_by?.email"
                        >
                          <span class="text-gray-600 text-xs">Email:</span>
                          {{ el.created_by?.email || "No email" }}
                        </div>
                      </td>
                      <td class="py-3 px-4 border-r text-left text-xs">
                        <div class="flex flex-col">
                          <span>{{ formatDate(el.created_at) }}</span>
                          <span class="text-xs text-gray-400">{{
                            formatTime(el.created_at)
                          }}</span>
                        </div>
                      </td>
                      <td class="py-3 px-4 border-r text-center text-xs">
                        {{ el.student_count || "0" }}
                      </td>
                    </tr>
                    <tr v-if="!Download_list.length">
                      <td
                        colspan="12"
                        class="py-10 text-center text-slate-400 text-sm"
                      >
                        No data found
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
              >
                <div
                  class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                >
                  <span class="flex md:hidden">Rows per page:</span>
                  <select
                    v-model="pageSize"
                    @change="onPageSizeChange"
                    class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>
                <div v-if="totalPages > 1" class="flex justify-center">
                  <Pagination
                    :totalPages="totalPages"
                    ref="paginationRef"
                    @page-changed="getDownloadLogs"
                  />
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex flex-col items-center justify-center min-h-[600px]"
            >
              No Data Found
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Modal -->
    <div
      v-if="showDeleteModal"
      class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center"
      @click.self="showDeleteModal = false"
    >
      <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div class="flex items-center justify-between p-4 border-b">
          <h3 class="text-lg font-semibold text-gray-900">Confirm Delete</h3>
          <button
            @click="showDeleteModal = false"
            class="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div class="p-6">
          <div class="flex flex-col justify-center items-center gap-2">
            <p class="text-gray-700">Are you sure you want to delete:</p>
            <p class="font-semibold text-textblues rounded-lg">
              "{{ selectedItem?.title }}"
            </p>
          </div>
        </div>
        <div
          class="flex items-center justify-end gap-3 p-4 border-t bg-gray-50 rounded-b-lg"
        >
          <button
            @click="showDeleteModal = false"
            class="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg text-sm font-medium transition-colors"
          >
            Close
          </button>
          <button
            @click="confirmDelete"
            class="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            Submit
          </button>
        </div>
      </div>
    </div>

    <!-- Preview Modal -->
    <div
      v-if="showModal"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      @click.self="closeModal"
    >
      <div
        class="bg-white rounded-2xl shadow-2xl w-[90%] max-w-4xl max-h-[90vh] flex flex-col overflow-hidden"
      >
        <div
          class="flex items-center justify-between px-6 py-4 border-b bg-gray-50 rounded-t-2xl"
        >
          <div>
            <h2 class="text-base font-semibold text-gray-800">Email Preview</h2>
          </div>
          <button
            @click="closeModal"
            class="text-gray-400 hover:text-gray-700 transition text-xl font-bold leading-none"
          >
            &times;
          </button>
        </div>
        <div class="flex-1 overflow-auto p-4 bg-gray-100">
          <iframe
            ref="previewFrame"
            class="w-full rounded-xl border border-slate-200 bg-white"
            style="height: 65vh"
            sandbox="allow-scripts allow-same-origin"
          ></iframe>
        </div>
        <div
          class="px-6 py-3 border-t bg-gray-50 flex justify-end rounded-b-2xl"
        >
          <button
            @click="closeModal"
            class="px-4 py-2 text-sm bg-blue-500 hover:bg-hover text-white rounded-lg transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Pagination from "@/components/Pagination.vue";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: { Header, Pagination, FlashMessage },

  data() {
    return {
      Download_list: [],
      searching: "",
      showModal: false,
      selectedLog: null,
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
      sendingSlug: null,
      downloadcount: 0,
      showDeleteModal: false,
      selectedItem: null,
      messages: {
        text: "",
        type: "null",
      },
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    this.getDownloadLogs(1);
  },

  methods: {
    getStepStatus(el) {
      const completed =
        (el.step_1 ? 1 : 0) + (el.step_2 ? 1 : 0) + (el.step_3 ? 1 : 0);
      return `${completed}/3`;
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      return new Date(dateString).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "numeric",
        year: "numeric",
      });
    },
    formatTime(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getDownloadLogs(1);
    },

    async getDownloadLogs(page) {
      this.currentPage = page;
      let params = {
        Key: this.userInfo.token_key,
        page: page,
        page_size: this.pageSize,
      };
      if (this.searching) {
        params.search = this.searching;
      }
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/student-report-log/`,
          { params },
        );
        if (response.data.data.status === 200) {
          this.Download_list = response?.data?.data?.data;
          this.totalPages = response.data.total_page;
          this.current_page = response.data.current_page;
          this.downloadcount = response.data.total;
        }
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * Handle edit navigation based on step_1, step_2, step_3 status
     *
     * Logic:
     * - step_1: true, step_2: false, step_3: false → Redirect to EmailDetails (Step 1)
     * - step_1: true, step_2: true, step_3: false → Redirect to EmailCompiler (Step 2)
     * - step_1: true, step_2: true, step_3: true → Redirect to EmailCreateCampaign (Step 3)
     * - step_1: false, step_2: false, step_3: false → Redirect to EmailDetails (Step 1)
     */
    handleEditNavigation(campaign) {
      const { step_1, step_2, step_3, slug, template } = campaign;

      // Determine which step to redirect to
      if (step_1 === true && step_2 === true && step_3 === true) {
        // Step 3 completed - go to step 3 (EmailCreateCampaign)
        this.$router.push({
          name: "EmailEditTemplate",
          params: {
            slug: slug,
            templateSlug: template?.slug,
          },
          query: { step: "1" },
        });
      } else if (step_1 === true && step_2 === true && step_3 === false) {
        // Step 2 completed but step 3 not - go to step 2 (EmailCompiler)
        this.$router.push({
          name: "EmailEditTemplate",
          params: {
            slug: slug,
            templateSlug: template?.slug,
          },
          query: { step: "2" },
        });
      } else {
        // No steps completed or step_1 is false - go to step 1 (EmailDetails)
        this.$router.push({
          name: "EmailEditTemplate",
          params: {
            slug: slug,
            templateSlug: template?.slug,
          },
          query: { step: "1" },
        });
      }
    },

    openPreview(log) {
      this.selectedLog = log;
      this.showModal = true;
      this.$nextTick(() => {
        const iframe = this.$refs.previewFrame;
        if (iframe) {
          const htmlContent =
            log?.template?.mail_content || "<p>No content available.</p>";
          const blob = new Blob([htmlContent], { type: "text/html" });
          const blobUrl = URL.createObjectURL(blob);
          iframe.src = blobUrl;
          iframe.onload = () => {
            URL.revokeObjectURL(blobUrl);
          };
        }
      });
    },

    closeModal() {
      this.showModal = false;
      this.selectedLog = null;
    },

    async handleSave(data) {
      try {
        this.sendingSlug = data.slug;
        const payload = {
          batch_json: data.batch_json?.map((item) => item.id) || [],
          department_json: data.department_json?.map((item) => item.id) || [],
          program_json: data.program_json?.map((item) => item.id) || [],
          semester_json: data.semester_json?.map((item) => item.id) || [],
        };
        const response = await axios.put(
          `${process.env.VUE_APP_API}/email-campaign/send/${data.slug}/`,
          payload,
          {
            params: {
              Key: this.userInfo?.token_key,
            },
          },
        );
        if (
          response?.data?.status === 200 ||
          response?.data?.data?.status === 200
        ) {
          this.getDownloadLogs(this.currentPage);
        }
      } catch (err) {
        console.error("PUT Error:", err.response?.data || err.message);
      } finally {
        setTimeout(() => {
          this.sendingSlug = null;
        }, 600);
      }
    },

    async confirmDelete() {
      this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/email-campaign/delete/${this.selectedItem.slug}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: "Event Failed",
              type: "error",
            };
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.showDeleteModal = false;
        this.getDownloadLogs(this.current_page);
      }, 2500);
    },
  },
};
</script>

<style></style>
